import { PulseStore } from '../store'

export function usePulseNavigation(total: number) {
  const page = PulseStore.use(state => state.page)

  const isFirst = page === 0
  const isLast = page === total - 1

  const onBack = () => {
    const current = PulseStore.get().page
    if (current <= 0) return

    PulseStore.set({ page: current - 1 })
  }

  const next = () => {
    const current = PulseStore.get().page
    if (current >= total - 1) return

    PulseStore.set({ page: current + 1 })
  }

  return {
    isFirst,
    isLast,
    onBack,
    next,
  }
}
